module.exports = __webpack_public_path__ + "static/img/5080_phase_function_Paper_PointsHejduk_Prediction.0580d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5080_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xTED
// module chunks = 0